import { inject } from '@angular/core';

import { filter, take } from 'rxjs';

import { AuthService } from '../services';

/**
 * Application-level route resolver.
 *
 * Triggers authentication validation and delays route activation
 * until the authentication system has finished initializing.
 *
 * This ensures that the user's authentication state is established
 * before the Angular router continues navigation, allowing guards
 * and components to safely rely on the auth state.
 *
 * The resolver listens to `authInitialised$` and completes once
 * the authentication initialization flag becomes `true`.
 *
 * @returns An Observable that completes once authentication
 *          initialization is finished.
 */
export async function appResolver() {
  const authService = inject(AuthService);

  await authService.validateAuthentication();

  return authService.authInitialised$.pipe(
    filter(isInitialised => isInitialised === true),
    take(1),
  );
}
